(ns hypnos.dme.panel.referral
  "The DME referral (lookup) page."
  (:require [hypnos.dme.core.patient :as core-patient]
            [hypnos.dme.subs]
            [hypnos.dme.tile.referral :as referral]
            [hypnos.graphql.queries :as queries]
            [re-frame.core :as rf]
            [reagent.core :as reagent]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Identities

(def ^{:private true} defaults
  {;; states
   :loading?            false ; loading in progress?
   :referral-looked-up? false ; did we lookup the referral?
   ;; referred patient
   :patient             {:patient/key              {:value    nil
                                                    :dirty?   false
                                                    :touched? false}
                         :patient/first-name       {:value    nil
                                                    :dirty?   false
                                                    :touched? false}
                         :patient/last-name        {:value    nil
                                                    :dirty?   false
                                                    :touched? false}
                         :patient/gender           {:value    nil
                                                    :dirty?   false
                                                    :touched? false}
                         :patient/dob              {:value    nil
                                                    :dirty?   false
                                                    :touched? false}
                         :patient/email            {:value    nil
                                                    :dirty?   false
                                                    :touched? false
                                                    :valid?   nil}
                         :patient/phone-number     {:value    nil
                                                    :dirty?   false
                                                    :touched? false
                                                    :valid?   nil}
                         :patient/alt-phone-number {:value    nil
                                                    :dirty?   false
                                                    :touched? false
                                                    :valid?   nil}
                         ;; the last consult
                         :patient/last-consult     {:consult/code         {:value    nil
                                                                           :dirty?   false
                                                                           :touched? false}
                                                    :consult/service-type {:value    :service-type/new-setup
                                                                           :dirty?   false
                                                                           :touched? false}
                                                    :consult/user         {:value    nil
                                                                           :dirty?   false
                                                                           :touched? false}
                                                    :consult/ahi          {:value    nil
                                                                           :dirty?   false
                                                                           :touched? false}
                                                    :consult/modality     {:value    nil
                                                                           :dirty?   false
                                                                           :touched? false}
                                                    :consult/cpap         {:value    nil
                                                                           :dirty?   false
                                                                           :touched? false}
                                                    :consult/ipap         {:value    nil
                                                                           :dirty?   false
                                                                           :touched? false}
                                                    :consult/epap         {:value    nil
                                                                           :dirty?   false
                                                                           :touched? false}}}})

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Helpers

(defn- default-patient-timezone
  [state org]
  (when-not (get-in @state [:patient :patient/timezone :value])
    (swap! state
           assoc-in [:patient :patient/timezone :value]
           (:organization/timezone org))))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Panel

(defn panel
  "The referral panel"
  [{:keys [_referral-code]}]
  (let [referral (rf/subscribe [:dme/referral])
        state    (reagent/atom defaults)]
    (rf/dispatch-sync [:dme/reset-referral])
    (fn [{:keys [referral-code]}]
      (when referral-code
        (when-not @referral
          (rf/dispatch [:amplify/query
                        queries/get-patient-by-referral-code
                        {:code referral-code}
                        :dme/set-referral
                        :dme/error])))
      (let [_auth        (rf/subscribe [:sleeplab/auth])
            organization (rf/subscribe [:dme/organization])
            _            (default-patient-timezone state @organization)
            referral     (rf/subscribe [:dme/referral])
            loading?     (rf/subscribe [:dme/gql-request-in-progress?])
            _            (when-not @loading? (core-patient/merge-referral-into-state state @referral))]
        [:section.is-main-section
         [:div.section
          [referral/patient-tile state]
          [referral/referral-tile state]]]))))
